import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid } from '@mui/material';
import { formatMoney, handleError } from '../Shared/Functions';
import { withToast } from '../Shared/Toast';
import { jsPDF } from "jspdf";
import { TokensVService } from '../../services/V3/gozer';

const PaymentReceipt = ({ transaction, setIsShowing, districtName, accountNumber, accountName, errorDetails, isAnon, existingToken, setLoading, success, fail }) => {
    const history = useHistory();
    const [saveToWallet, setSaveToWallet] = useState<boolean>(false);

    const handleContinue = () => {

        if (saveToWallet) {
            setLoading(true)
            TokensVService.tokensVUpdateToken(transaction.billingAccountId, transaction.tokenId, { saveToWallet: true })
                .then(x => {
                    if (x.tokenType === "CC") {
                        success("Successfully added Credit Card")
                    }
                    else {
                        success("Successfully added Bank Account")
                    }
                    setLoading(false)
                })
                .catch(err => {
                    err.message !=="Not Found" && fail(handleError(err))
                    setLoading(false)
                })
        }

        setIsShowing(false);
        if(!errorDetails && !isAnon) history.push('/account');
        if(!errorDetails && isAnon) history.push('/sign-in');
    }

    const download = async() => {
        const pdf = new jsPDF("portrait", "pt", "letter");
        const data = document.querySelector("#pdfprint")?.innerHTML ?? new HTMLElement();

        await pdf.html(data, {
            width: 1000,
            windowWidth: 1000
        })
        
        pdf.save("PaymentTransactionReceipt.pdf");
    }

    return <>
        <div hidden id="pdfprint">
            <div className='receipt'>
                <div><h6><b>Payment Receipt for {districtName}</b></h6></div>
                <p>Thank you for your payment!</p>
                <div className='receipt-item'>
                    <div><b>Payment Date:</b>&nbsp;</div>
                    <div>{new Date(transaction.createdAt).toLocaleDateString()}</div>
                </div>
                <div className='receipt-item'>
                    <div><b>Account Number:</b>&nbsp;</div>
                    <div>{accountNumber}</div>
                </div>
                <div className='receipt-item'>
                    <div><b>Account Name:</b>&nbsp;</div>
                    <div>{accountName}</div>
                </div>
                {transaction?.token &&
                    <div className='receipt-item'>
                        <div><b>Payment Method:</b>&nbsp;</div>
                        <div>{transaction.token.cardType ?? transaction.token.achType} ****{transaction.token.last4}</div>
                    </div>
                }
                <div className='receipt-item'>
                    <div><b>Payment Amount:</b>&nbsp;</div>
                    <div>{formatMoney(transaction.amount)}</div>
                </div>
                <div className='receipt-item'>
                    <div><b>Service Fee:</b>&nbsp;</div>
                    <div>{formatMoney(transaction.serviceFeeAmount)}</div>
                </div>
                <div className='receipt-item'>
                    <div><b>Total Amount:</b>&nbsp;</div>
                    <div>{formatMoney((Number.parseFloat(transaction?.amount) + Number.parseFloat(transaction.serviceFeeAmount))?.toFixed(2))}</div>
                </div>
                <div className='receipt-item'>
                    <div><b>Payment Status:</b>&nbsp;</div>
                    <div>{(errorDetails || transaction.error) ? "Declined" : "Approved"}</div>
                </div>
                <div className='receipt-item'>
                    <div>{!(errorDetails || transaction.error) ? <b>Confirmation Number:</b> : <b>Details:</b>}&nbsp;</div>
                    <div>{(errorDetails || transaction.error) ?? transaction.confirmationNumber}</div>
                </div>
                <br/>
                <p>Thank you for your business. We look forward to continuing to serve you.</p>
                <p>
                    Regards, <br/>
                    {districtName}
                </p>
            </div>
        </div>
        <Dialog
            onClose={() => { }}
            open={true}>
            <DialogTitle>Payment Details</DialogTitle>
            <DialogContent>
                <div id="pdf" style={{padding: "0px 10px 0px 10px"}}>
                    <h3>{districtName}</h3>
                    <Grid container>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Transaction Date</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {new Date(transaction.createdAt).toLocaleDateString()}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Account Number</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {accountNumber}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Payment Amount</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {formatMoney(transaction.amount)}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Service Fee</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {formatMoney(transaction.serviceFeeAmount)}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Total</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {formatMoney((Number.parseFloat(transaction?.amount) + Number.parseFloat(transaction.serviceFeeAmount))?.toFixed(2))}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Payment Type</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {transaction?.token?.tokenType ?? transaction.paymentType}
                        </Grid>
                        {transaction?.token &&
                            <>
                                <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                                    <b>Payment Method</b>
                                </Grid>
                                <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                                    {transaction.token.cardType ?? transaction.token.achType} {transaction.token.last4}
                                </Grid>
                            </>
                        }
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            <b>Status</b>
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {(errorDetails || transaction.error) ? "Declined" : "Approved"}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {!(errorDetails || transaction.error) ? <b>Confirmation Number</b> : <b>Details</b>}
                        </Grid>
                        <Grid item xs={6} md={5} style={{paddingBottom:"5px"}}>
                            {(errorDetails || transaction.error) ?? transaction.confirmationNumber}
                        </Grid>
                    </Grid>
                </div>
                {(transaction.displayResult === "Approved" && !existingToken && !isAnon) &&
                    <FormControlLabel
                        label="Save to wallet"
                        labelPlacement="end"
                        style={{padding: "0px 0px 0px 10px"}}
                        control={
                            <Checkbox
                                checked={saveToWallet}
                                onChange={x => setSaveToWallet(x.target.checked)}
                                color="primary" />
                        } />
                }
                <div className='payment-modal-buttons-group'>
                    <Button variant="outlined"
                        color="primary"
                        onClick={async () => await download()}
                        className="m-2"
                        style={{marginRight:"10px"}}>Print Receipt</Button>
                    <Button variant="contained"
                        color="primary"
                        onClick={handleContinue}
                        className="m-2">Continue</Button>
                </div>
            </DialogContent>
        </Dialog>
    </>
}
export default withToast(PaymentReceipt);